import * as React from "react";
import MDBox from "components/MDBox";
import BaseCard from "../../molecules/Cards/BaseCard";

const CardRow = ({ cards = [], freeTrialPlan }) => (
  <MDBox
    sx={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px" }}
  >
    {cards.map((card) => (
      <BaseCard key={card.title} {...card} freeTrialPlan={freeTrialPlan} />
    ))}
  </MDBox>
);

export default CardRow;
